import DefaultBlock from "/scripts/default/block";
import gsap from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import { ScrollTrigger } from "gsap/all";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

export default class CoreIntro extends DefaultBlock {
	init() {
		const flair = this.block.querySelector(".core-intro__flair");
		this.flair = flair;

		const el = {
			circle: flair.querySelector("#core_intro_circle"),
			marker: flair.querySelector("#core_intro_marker"),
			tube: flair.querySelector("#core_intro_tube"),
			tubeMarker: flair.querySelector("#core_intro_tube_marker"),
			path: flair.querySelector("#core_intro_path"),
		};
		this.el = el;

		this.tl = null;
		this.bounds = null;

		this.initCoreIntro();
	}

	getCoreIntroBounds() {
		this.bounds = this.el.tubeMarker.getBoundingClientRect();
	}

	setCoreIntro() {
		gsap.set([this.el.tubeMarker, this.el.circle], {
			x: this.bounds.width,
			autoAlpha: 1,
		});
	}

	playCoreIntro() {
		this.tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.flair,
				start: "top-=125% center",
			},
		});

		this.tl.to(
			[this.el.tubeMarker, this.el.circle],
			{
				x: 0,
				duration: 0.8,
				ease: "back.out(1.5)",
			},
			0
		);

		this.tl.to(
			this.el.marker,
			{
				keyframes: {
					x: [0, -10, 0],
				},
				duration: 1,
				ease: "back.out(1.5)",
			},
			0.4
		);

		this.tl.to(
			this.el.circle,
			{
				x: -this.bounds.left,
				ease: "back.out(1.5)",
				duration: 1,
			},
			">-1.2"
		);

		this.tl.to(this.el.circle, {
			autoAlpha: 0,
		});
	}

	handleAnimate() {
		this.getCoreIntroBounds();
		this.setCoreIntro();
		this.playCoreIntro();
	}

	handleResize() {
		this.tl.kill();

		this.handleAnimate();
	}

	initCoreIntro() {
		watchPreferredMotion(() => {
			this.handleAnimate();
		});

		// window.addEventListener("resize", this.handleResize.bind(this));
	}
}
